/**
 * Мелкие проверки формы ответа на границе (D-056). Каждая бросает `Error` с
 * путём до поля: transport превращает его в `invalid-response`, а экран
 * показывает понятный отказ вместо `undefined.name`.
 */
export function fail(message: string): never {
  throw new Error(message)
}

export type Raw = Record<string, unknown>

export function asObject(value: unknown, path: string): Raw {
  if (typeof value !== 'object' || value === null || Array.isArray(value)) return fail(`${path}: ожидался объект`)
  return value as Raw
}

export function asArray(value: unknown, path: string): readonly unknown[] {
  return Array.isArray(value) ? (value as unknown[]) : fail(`${path}: ожидался массив`)
}

export function asString(value: unknown, path: string): string {
  return typeof value === 'string' ? value : fail(`${path}: ожидалась строка`)
}

export function asNumber(value: unknown, path: string): number {
  return typeof value === 'number' && Number.isFinite(value) ? value : fail(`${path}: ожидалось число`)
}

export function asBoolean(value: unknown, path: string): boolean {
  return typeof value === 'boolean' ? value : fail(`${path}: ожидалось логическое значение`)
}

/** Необязательное поле: нет или `null` — `null`. */
export function optional<T>(value: unknown, path: string, read: (raw: unknown, path: string) => T): T | null {
  return value === undefined || value === null ? null : read(value, path)
}

export function field(raw: Raw, name: string, path: string): unknown {
  return raw[name] === undefined ? fail(`${path}.${name}: поле отсутствует`) : raw[name]
}

export function mapArray<T>(value: unknown, path: string, read: (item: unknown, path: string) => T): readonly T[] {
  return asArray(value, path).map((item, index) => read(item, `${path}[${index}]`))
}

/** Перечисление сервера (строка из закрытого списка). */
export function asOneOf<T extends string>(value: unknown, path: string, allowed: readonly T[]): T {
  const text = asString(value, path)
  return (allowed as readonly string[]).includes(text) ? (text as T) : fail(`${path}: неизвестное значение «${text}»`)
}
